<template>
  <div class="details">
    <header>
      <p>
        <img
          v-if="order.orderstatus == 5 || order.orderstatus == 6"
          src="../../assets/images/right.png"
        />
        <img v-if="order.orderstatus == 0" src="../../assets/images/close2.png" />
        <img v-if="order.orderstatus == 1" src="../../assets/images/order.png" />
        <img
          v-if="order.orderstatus == 2 || order.orderstatus == 7"
          src="../../assets/images/sendgood.png"
        />
        <img v-if="order.orderstatus == 4" src="../../assets/images/refund1.png" />
        {{ order.orderstatus_text }}
      </p>
      <span v-if="order.orderstatus_sub_text && order.orderstatus_sub_text != ''">
        {{ order.orderstatus_sub_text }}
      </span>
      <span
        v-if="
          !order.orderstatus_sub_text && order.orderstatus_sub_text == '' && order.orderstatus == 1
        "
        class="countDown"
      >
        剩余
        <van-count-down class="d-ib" :time="time" :format="format" @finish="closeOrder('close')" />
        关闭交易
      </span>
      <span
        v-if="
          !order.orderstatus_sub_text &&
          order.orderstatus_sub_text == '' &&
          order.orderstatus == 7 &&
          order.status == 4
        "
        class="countDown"
      >
        还剩
        <van-count-down class="d-ib" :time="time" :format="format" @finish="selfMotionConfirm" />
        自动确认
      </span>
    </header>
    <div class="order recommend" v-if="order.recommenditemlist && order.recommenditemlist.length">
      <div class="title f0 flex-ac">
        <img src="/static/images/recommend/recommended@2x.png" />
        <span class="f12">你可能还会喜欢</span>
        <van-icon
          class="close"
          name="cross"
          color="#B3B3B3"
          size="0.14rem"
          @click="closeRecommend"
        />
      </div>
      <div :class="[order.recommenditemlist.length == 3 ? 'flex-js-as' : 'flex-ac']">
        <div
          class="recommenditem f0"
          v-for="item of order.recommenditemlist"
          @click="$router.push('/productdetail?itemid=' + item.itemid)"
        >
          <img class="flex-s" :src="item.img_path" alt="" />
          <div class="price ta-c">
            <span class="xprice">
              <sub>¥</sub>
              <b>
                {{
                  String(parseFloat(item.price).toFixed(2)).slice(
                    0,
                    String(parseFloat(item.price).toFixed(2)).indexOf('.')
                  )
                }}
              </b>
              <sup>
                {{
                  String(parseFloat(item.price).toFixed(2)).slice(
                    String(parseFloat(item.price).toFixed(2)).indexOf('.'),
                    String(parseFloat(item.price).toFixed(2)).length
                  )
                }}
              </sup>
            </span>
            <span class="f10 xprice cost_price">
              <sub>¥{{ item.cost_price }}</sub>
            </span>
          </div>
          <span v-if="item.tag" class="f11 color-FC0324">{{ item.tag }}</span>
        </div>
      </div>
    </div>
    <div class="address">
      <ul>
        <li
          class="trans"
          v-if="
            ((order.orderstatus == 2 &&
              (order.status == 3 || order.status == 4 || order.status == 5 || order.status == 6)) ||
              ((order.orderstatus == 3 || order.orderstatus == 6) && order.status == 6) ||
              order.orderstatus == 7) &&
            transList.length
          "
        >
          <div class="p ai-fs">
            <img class="mt5" src="../../assets/images/logistics.png" />
            <div class="flex-1 w-92">
              <div
                class="flex jc-sb mb10 ai-c"
                @click="goMorePackage()"
                v-if="transList && transList.length >= 2"
              >
                <div class="scroll-x flex fw-n mr10 scrollbar-none">
                  <van-tag
                    class="mt0 mr10 pl5 pr5 flex-s"
                    type="primary"
                    size="large"
                    :color="transIndex == index ? '#fc0324' : '#333333'"
                    @click.stop="transIndex = index"
                    plain
                    v-for="(item, index) of transList"
                    :key="index"
                  >
                    包裹{{ index + 1 }}
                  </van-tag>
                </div>
                <van-icon name="arrow" size="0.1rem" color="#000000" />
              </div>
              <template v-for="(item, index) of transList">
                <template v-if="transIndex == index">
                  <div class="font_w-n mb10 f10 color-0">
                    {{ item.transname + ' ' + item.transno }}
                  </div>
                  <template
                    v-if="(order.orderstatus == 3 || order.orderstatus == 6) && order.status == 6"
                  >
                    <div class="p" @click="goLogistics()">
                      <div>
                        {{ order.trans_title }}
                        <van-icon name="arrow" size="0.1rem" color="#000000" />
                      </div>
                    </div>
                    <span class="pl0">{{ order.trans_desc }}</span>
                    <span class="pl0">{{ order.tran_time }}</span>
                  </template>
                  <template v-else>
                    <div @click="goLogistics()">
                      {{ item.list && item.list.length ? '订单正在运输中' : '订单正在发货中' }}
                      <van-icon name="arrow" size="0.1rem" color="#000000" />
                    </div>
                    <span @click="goLogistics()" class="pl0" v-if="item.list && item.list.length">
                      {{ item.list[0] ? item.list[0].info : '' }}
                    </span>
                    <span @click="goLogistics()" class="pl0" v-if="item.list && item.list.length">
                      {{ item.list[0] ? item.list[0].time : '' }}
                    </span>
                  </template>
                </template>
              </template>
            </div>
          </div>
        </li>
        <li
          class="trans"
          v-else-if="
            order.orderstatus != 0 &&
            order.orderstatus != 1 &&
            (order.trans_title != '' || order.trans_desc != '' || order.tran_time != '')
          "
        >
          <div class="p" @click="tranClick(order.issplit)">
            <img src="../../assets/images/logistics.png" />
            <div>
              {{ order.trans_title }}
              <van-icon name="arrow" size="0.1rem" color="#000000" />
            </div>
          </div>
          <span>{{ order.trans_desc }}</span>
          <span>{{ order.tran_time }}</span>
        </li>
        <li v-if="order.getteraddress != '' && order.getteraddress != null">
          <div class="p jc-sb">
            <b>
              <img class="pt1 pb1 pl2 pr2" src="../../assets/images/position.png" />
              {{ order.gettername }}
              <strong class="pl8">{{ order.gettermobile }}</strong>
            </b>
            <b class="fw-400" v-if="order.isedit == 1" @click="address(order.isedit)">
              修改
              <van-icon name="arrow" size="0.1rem" color="#000000" />
            </b>
          </div>
          <span class="f11 color-95" style="line-height: 0.16rem">
            {{ order.getteraddress }}
          </span>
          <p class="color-FC0324 mt4 f12 flex" v-if="order.areaException == 1">
            <img
              class="pt2 pb2 pl2 pr2"
              style="width: 0.16rem; height: 0.16rem"
              src="../../assets/images/presell.png"
            />
            订单地址异常，无法正常发货
          </p>
        </li>
      </ul>
    </div>
    <div class="order" :class="{ 'order-top-pad': relationorders.length > 0 }">
      <span
        class="f12 color-FC0324"
        @click.stop="relationordersFn"
        v-if="relationorders.length > 0"
      >
        查看补发订单
      </span>
      <div
        @click="goProductList"
        class="changebuy mb7"
        v-if="order.changebuystatus || order.isexchange"
      >
        <div class="left">
          <img
            v-if="order.changebuystatus && order.isexchange"
            src="/static/images/changebuy/shopping-icon-bargain.png?v=1"
          />
          <img
            v-else-if="order.changebuystatus"
            src="/static/images/changebuy/shopping-icon-bargain-2.png?v=1"
          />
          <img v-else src="/static/images/changebuy/shopping-icon-bargain-1.png?v=1" />
          <p>
            购买该商品可享受超值{{
              order.changebuystatus && order.isexchange
                ? '福利'
                : order.changebuystatus
                ? '换购'
                : '加购'
            }}
          </p>
        </div>
        <div class="right" @click="goProductList">
          <p>
            去{{
              order.changebuystatus && order.isexchange
                ? '参与'
                : order.changebuystatus
                ? '换购'
                : '加购'
            }}
          </p>
          <van-icon name="arrow" size="0.1rem" color="#1D1E1E" />
        </div>
      </div>
      <ul>
        <li v-for="(item, index) of list" :key="index">
          <div class="orderlist" @click="productDetailFn(item)">
            <div class="img">
              <img v-lazy="item.img_path" />
              <goods-tag :goods="item"></goods-tag>
            </div>
            <div class="ordercontent">
              <p>
                <i v-if="item.name" class="fs-n">
                  {{ item.name.length > 26 ? item.name.slice(0, 26) + '...' : item.name }}
                  <img
                    v-if="item.isoversea == 1"
                    class="d-ib"
                    style="vertical-align: sub; width: 0.15rem; height: 0.15rem"
                    src="../../assets/images/haiwai.png"
                  />
                </i>
                <b>X{{ item.nums }}</b>
              </p>
              <b>{{ item.spec }}</b>
              <div class="flex-js-as">
                <div class="price">
                  <span class="xprice">
                    <sub>¥</sub>
                    <b
                      v-text="
                        String(parseFloat(item.price).toFixed(2)).slice(
                          0,
                          String(parseFloat(item.price).toFixed(2)).indexOf('.')
                        )
                      "
                    ></b>
                    <sup
                      v-text="
                        String(parseFloat(item.price).toFixed(2)).slice(
                          String(parseFloat(item.price).toFixed(2)).indexOf('.'),
                          String(parseFloat(item.price).toFixed(2)).length
                        )
                      "
                    ></sup>
                    <span v-if="parseFloat(item.finalpaymentmoney) > 0">
                      <sub class="color-fc0324">&nbsp;尾款¥</sub>
                      <b
                        class="color-fc0324"
                        v-text="
                          String(parseFloat(item.finalpaymentmoney).toFixed(2)).slice(
                            0,
                            String(parseFloat(item.finalpaymentmoney).toFixed(2)).indexOf('.')
                          )
                        "
                      ></b>
                      <sup
                        class="color-fc0324"
                        v-text="
                          String(parseFloat(item.finalpaymentmoney).toFixed(2)).slice(
                            String(parseFloat(item.finalpaymentmoney).toFixed(2)).indexOf('.'),
                            String(parseFloat(item.finalpaymentmoney).toFixed(2)).length
                          )
                        "
                      ></sup>
                    </span>
                  </span>
                  <div class="tags" v-if="item.birthdayDiscount">{{ item.birthdayDiscount }}</div>
                </div>
                <div class="price">
                  <span class="xprice color-FC0324" v-if="parseFloat(item.afterfullMinusMoney) > 0">
                    <sub>实付款：¥</sub>
                    <b
                      v-text="
                        String(parseFloat(item.afterfullMinusMoney).toFixed(2)).slice(
                          0,
                          String(parseFloat(item.afterfullMinusMoney).toFixed(2)).indexOf('.')
                        )
                      "
                    ></b>
                    <sup
                      v-text="
                        String(parseFloat(item.afterfullMinusMoney).toFixed(2)).slice(
                          String(parseFloat(item.afterfullMinusMoney).toFixed(2)).indexOf('.'),
                          String(parseFloat(item.afterfullMinusMoney).toFixed(2)).length
                        )
                      "
                    ></sup>
                  </span>
                </div>
              </div>
              <div class="f0 tag flex-ac flex-w mt4" v-if="item.freightrule.payfreight_tag == 1 || item.freightrule.payfreight_tag == 2">
                <van-tag class="tag_danger mt3 mr5" type="danger" style="line-height: normal">
                  {{item.freightrule.payfreight_tag == 2 ? '固定运费' : ''}}不包邮
                </van-tag>
              </div>
            </div>
          </div>
          <div class="btn1">
            <div class="ys">
              <div class="ysale" v-if="item.ispresale == 1 && item.presaletime != ''">
                <van-tag color="#FEE9E6" text-color="#F12A0E">预售</van-tag>
                <img src="../../assets/images/presell.png" />
                <div class="txt">预售发货时间：{{ item.presaletime }}</div>
              </div>
            </div>
            <div class="btn mt5">
              <button
                v-if="
                  order.issplit != 1 &&
                  (item.isgift != 1 || (item.isgift == 1 && parseFloat(item.price || 0) > 0)) &&
                  item.isprogift != 1 &&
                  item.refundNum > 0 &&
                  list &&
                  list.length > 0 &&
                  item.orderstatus == 2 &&
                  order.is_coupon != 1 &&
                  order.is_show_refund_button == 1 &&
                  item.is_show_refund_button == 1 &&
                  order.isMayTwentyAct == 0 &&
                  !isadditemFlag
                "
                class="grayBtn"
                @click="afterSalesFn(0, item)"
              >
                申请退款
              </button>
              <button
                v-if="
                  order.issplit != 1 &&
                  (item.isgift != 1 || (item.isgift == 1 && parseFloat(item.price || 0) > 0)) &&
                  item.isprogift != 1 &&
                  item.refundNum > 0 &&
                  list &&
                  list.length > 0 &&
                  item.orderstatus == 3 &&
                  order.is_coupon != 1 &&
                  order.is_show_refund_button == 1 &&
                  item.is_show_refund_button == 1 &&
                  order.isMayTwentyAct == 0 &&
                  !item.isadditem
                "
                class="grayBtn"
                @click="afterSalesFn(0, item)"
              >
                申请售后
              </button>
              <button
                v-if="
                  list &&
                  list.length > 0 &&
                  (item.isgift != 1 ||
                    (item.isgift == 1 && parseFloat(item.price).toFixed(2) > 0)) &&
                  item.isprogift != 1 &&
                  (item.orderstatus == 2 ||
                    item.orderstatus == 3 ||
                    item.orderstatus == 4 ||
                    item.orderstatus == 5 ||
                    item.orderstatus == 7) &&
                  order.is_coupon != 1 &&
                  item.refund_id != '' &&
                  !item.isadditem
                "
                class="grayBtn"
                @click="afterDetailsClick('0', item)"
              >
                售后详情
              </button>
              <button
                v-if="
                  list &&
                  list.length > 0 &&
                  order.isparintergral != 1 &&
                  item.isgift != 1 &&
                  item.isprogift != 1 &&
                  ((item.orderstatus == 3 && item.iscomment != 1) ||
                    (item.orderstatus == 6 && item.iscomment != 1))
                "
                class="redBtn"
                @click="evaluate('item', item)"
              >
                评价晒单
              </button>
              <button
                v-if="
                  list &&
                  list.length > 0 &&
                  order.isparintergral == 1 &&
                  item.isgift != 1 &&
                  item.isprogift != 1 &&
                  ((item.orderstatus == 3 && item.iscomment != 1) ||
                    (item.orderstatus == 6 && item.iscomment != 1))
                "
                class="redBtn"
                @click="evaluate('item', item)"
              >
                评价赚金币
              </button>
            </div>
          </div>
        </li>
        <li @click="keFu">
          <img src="../../assets/images/kefu.png" />
          联系客服
        </li>
      </ul>
    </div>
    <div class="money">
      <ul>
        <li>
          商品总价
          <b>¥{{ parseFloat(order.item_money ? parseFloat(order.item_money) : 0).toFixed(2) }}</b>
        </li>
        <li>
          <span class="flex">
            运费
            <img
              class="ml2"
              style="width: 0.16rem; height: 0.16rem"
              v-if="order.freightrule"
              @click="freightruleShow = true"
              src="../../assets/images/integralrule.png"
            />
            <span class="color-8B" v-if="order.weight_val">
              &nbsp;不包邮品共{{ order.weight_val }}kg
            </span>
          </span>
          <b>¥{{ parseFloat(order.trans_money ? parseFloat(order.trans_money) : 0).toFixed(2) }}</b>
        </li>
        <li>
          订单总价
          <b>¥{{ parseFloat(order.order_money ? parseFloat(order.order_money) : 0).toFixed(2) }}</b>
        </li>
      </ul>
      <ul>
        <li v-if="parseFloat(order.integernumber) > 0">
          金币抵扣&nbsp;使用{{ parseInt(order.integernumber) }}金币
          <b v-if="parseFloat(order.integral_money) > 0">
            ¥{{ parseFloat(order.integral_money).toFixed(2) }}
          </b>
        </li>
        <li v-if="parseFloat(order.depositmoney) > 0">
          定金翻倍(含定金)
          <b>-¥{{ parseFloat(order.depositmoney).toFixed(2) }}</b>
        </li>
        <li v-if="parseFloat(order.fullMinusMoney) > 0">
          全场满减
          <b>-¥{{ order.fullMinusMoney }}</b>
        </li>
        <li v-if="parseFloat(order.extraFullMinusMoney) > 0">
          返场优惠
          <b>-¥{{ order.extraFullMinusMoney }}</b>
        </li>
        <li v-if="parseFloat(order.coupon_money) > 0">
          现金券
          <b>¥{{ parseFloat(order.coupon_money).toFixed(2) }}</b>
        </li>
        <li v-if="couponname">
          产品劵
          <b>{{ couponname }}</b>
        </li>
        <li v-if="order.discount && order.discount.length > 0">
          活动
          <div>
            <b class="d-b" v-for="(item, index) in order.discount" v-if="item.money > 0">
              {{ item.name }} -¥{{
                parseFloat(item.money ? parseFloat(item.money) : '0.00').toFixed(2)
              }}
            </b>
          </div>
        </li>
        <li v-if="parseFloat(order.morediscounts_money) > 0">
          多件立减
          <b>
            -¥{{
              parseFloat(
                order.morediscounts_money ? parseFloat(order.morediscounts_money) : '0.00'
              ).toFixed(2)
            }}
          </b>
        </li>
        <li v-if="parseFloat(order.livecouponmoney) > 0">
          直播间福利
          <b>-¥{{ parseFloat(order.livecouponmoney) }}</b>
        </li>
        <li v-if="order.orderstatus == 1 && order.status == 1">
          应付款:
          <b>¥{{ order.nopay_money }}</b>
        </li>
        <li v-if="order.orderstatus != 1 && order.status != 1">
          实付款:
          <b>¥{{ parseFloat(order.pay_money ? order.pay_money : 0).toFixed(2) }}</b>
        </li>
      </ul>
    </div>
    <div class="orderSource" v-if="order && order.order_from">
      <ul>
        <li class="flex" v-if="order.remark && order.remark != ''">
          <div class="ws-n">订单备注：</div>
          <b>{{ order.remark }}</b>
        </li>
        <li v-if="order.order_from && order.order_from != ''">
          订单来源：
          <b>{{ order.order_from }}</b>
        </li>
        <li v-if="order.no && order.no != ''">
          订单编号：
          <b class="orderNo">
            <input id="orderNo" type="text" :value="order.no" readonly="readonly" />
            {{ order.no }}
          </b>
          <i v-if="order.no" @click="copy">复制</i>
        </li>
        <li v-if="order.ordertime && order.ordertime != ''">
          创建时间：
          <b>{{ order.ordertime }}</b>
        </li>
        <li v-if="order.paytime && order.paytime != ''">
          支付时间：
          <b>{{ order.paytime }}</b>
        </li>
        <li v-if="order.paymethod && order.paymethod != ''">
          支付方式：
          <b>{{ order.paymethod }}</b>
        </li>
        <li v-if="parseInt(order.get_integral) > 0">
          金币奖励：
          <b>{{ order.get_integral }}</b>
        </li>
        <li v-if="parseInt(order.goodsrefundmoney) > 0">
          商品退款：
          <b>{{ order.goodsrefundmoney }}</b>
        </li>
        <li v-if="parseInt(order.freightrefundmoney) > 0">
          运费退款：
          <b>{{ order.freightrefundmoney }}</b>
        </li>
        <li class="flex" v-if="order.refundtime && order.refundtime.length">
          退款时间：
          <div>
            <b v-for="item of order.refundtime">
              &nbsp;{{ item }}
              <br />
            </b>
          </div>
        </li>
      </ul>
    </div>
    <footer class="btn footerIOS">
      <button
        @click="delOrder"
        class="grayBtn"
        v-if="
          order.orderstatus == 0 ||
          order.orderstatus == 3 ||
          order.orderstatus == 6 ||
          order.orderstatus == 5
        "
      >
        删除订单
      </button>
      <button
        v-if="
          ((order.orderstatus == 2 && order.status == 5) ||
            order.orderstatus == 3 ||
            order.orderstatus == 7) &&
          order.is_show_refund_button == 1
        "
        class="grayBtn"
        @click="afterSalesFn(1)"
      >
        申请售后
      </button>
      <button
        v-if="
          order.orderstatus == 2 &&
          order.status != 5 &&
          order.is_coupon != 1 &&
          order.is_show_refund_button == 1
        "
        class="grayBtn"
        @click="afterSalesFn(1)"
      >
        申请退款
      </button>
      <button v-if="order.orderstatus == 1" class="grayBtn" @click="closeOrder">取消订单</button>
      <button
        v-if="
          (order.orderstatus == 0 || order.orderstatus == 4 || order.orderstatus == 5) &&
          order.is_act_order != 1 &&
          order.isdeposit != 1 &&
          order.isMayTwentyAct == 0
        "
        class="redBtn"
        @click="buyAgain"
      >
        重新购买
      </button>
      <button
        v-if="
          (order.orderstatus == 2 && order.status != 2) ||
          (order.orderstatus == 7 && order.status == 4)
        "
        class="redBtn"
        @click="confirm"
      >
        确认收货
      </button>
      <button v-if="order.orderstatus == 1" class="redBtn" @click="goBuy">去支付</button>
      <button
        v-if="
          (order.orderstatus == 3 || order.orderstatus == 6) &&
          order.is_act_order != 1 &&
          order.isdeposit != 1 &&
          order.isMayTwentyAct == 0
        "
        class="redBtn"
        @click="buyAgain"
      >
        再次购买
      </button>
    </footer>
    <div class="homeBtn" @click="homeClick">
      <img src="/static/images/homebtn.png" />
    </div>
    <van-dialog
      class="collect_button_alert after-sales-dialog"
      v-model="afterSalesShow"
      :message="afterSalesMessage"
      :before-close="beforeClose"
      @confirm="confirmDialog"
      @cancel="cancelDialog"
      confirm-button-text="联系客服"
      confirm-button-color="#FFFCFC"
      cancel-button-text="拨打电话"
      cancel-button-color="#FC0324"
      show-confirm-button
      show-cancel-button
    >
      <div slot="title">
        <img class="dialog-close" @click="closeDialogFn" src="../../assets/images/close3.png" />
      </div>
    </van-dialog>
    <van-overlay :lock-scroll="false" :show="freightruleShow" z-index="99999">
      <div class="wrapper freightrule_box">
        <div class="block" @click.stop style="height: 70%; width: 90%">
          <div>
            <p class="pb10">运费规则说明</p>
            <div
              class="freightrule f13 scroll-y ta-l"
              style="height: 93%"
              v-html="order.freightrule"
            ></div>
            <!-- <span class="f13">的撒发违法第三CD萨达撒付费大法师法师法师</span> -->
          </div>
          <van-icon @click="freightruleShow = false" name="close" />
        </div>
      </div>
    </van-overlay>
    <order-goods-check
      ref="orderGoodsCheck"
      :goods="refundGoods"
      :order="order"
      @submit="afterSalesSubmit"
      @close="afterSalesType = -1"
    />
    <awesome-picker
      ref="pickerRef"
      :textTitle="picker.textTitle"
      :data="picker.data"
      :anchor="picker.anchor"
      @confirm="handlePickerConfirm"
    ></awesome-picker>
  </div>
</template>

<script>
import {
  isWeixin,
  kefu,
  fenxiang,
  copyContentH5,
  isWx,
  download_dialog
} from '../../assets/common/js/config'
import {
  afterSalesHandle,
  refundGoodsList,
  refundActivityPrizeTip,
  refundGoods
} from './js/methods'
import { Tag } from 'vant'
import goodsTag from '../common/goodsTag'
import orderGoodsCheck from './components/orderGoodsCheck.vue'
export default {
  name: 'orderDetails',
  components: {
    [Tag.name]: Tag,
    goodsTag,
    orderGoodsCheck
  },
  data() {
    return {
      id: this.$route.query.id ? this.$route.query.id : '',
      time: 0,
      format: 'DD 天 HH 时 mm 分 ss 秒',
      order: {},
      list: [],
      refundGoods: [],
      couponname: '',
      afterSalesShow: false,
      afterSalesMessage: '',
      kefuPhone: '',
      isadditemFlag: 0, // 0/1 非加购/加购商品
      relationorders: [],
      freightruleShow: false,
      transList: [] /**物流信息数据 */,
      transIndex: 0 /**单个物流信息索引 */,
      afterSalesType: -1 /**0 单个申请 2 整单申请 */,
      picker: {
        anchor: [],
        textTitle: '退款类型',
        data: [['整单全退', '部分退款']]
      }
    }
  },
  created() {
    var url_p = this.$route.fullPath
    if (url_p.indexOf('listType=') < 0) url_p += '&listType=2'
    this.$router.replace(url_p)
  },
  mounted: function () {
    if (isWeixin()) {
      fenxiang({ path: 'orderdetails' })
    }
    if (this.$route.query.status == 'success') {
      this.$toast('修改成功')
    } else if (this.$route.query.receivestatus == 'success') {
      this.$toast('领取成功')
    }
    this.getData()
  },
  beforeRouteEnter: function (to, from, next) {
    if (
      from.path != '/orderdetails' &&
      from.path != '/splitdetails' &&
      from.path != '/addresschoose' &&
      from.path != '/productdetail' &&
      from.path != '/aftertype' &&
      from.path != '/pay' &&
      from.path != '/allProductList' &&
      from.path != '/productList' &&
      from.path != '/producteval' &&
      from.path != '/cart'
    ) {
      // 当前页面刷新不需要切换位置
      sessionStorage.removeItem('recommendclose')
    }
    next()
  },
  destroyed: function () {
    this.$toast.clear()
    this.$dialog.close()
  },
  methods: {
    getData: function () {
      var url = this.$ajax.getOrderById_URL + '?id=' + this.id
      var that = this
      that.$customRequestAjax(url).then((res) => {
        if (res.data.code === 200) {
          that.order = res.data
          that.transList = []
          that.transHandle()
          this.order.freightrule = this.order.freightrule || ''
          let discountmoney = 0
          if (this.order.discount && this.order.discount.length) {
            this.order.discount.map((item) => {
              discountmoney += parseFloat(item.money)
            })
          }
          this.order.nopay_money = parseFloat(
            this.order.order_money
              ? parseFloat(this.order.order_money) -
                  (parseFloat(this.order.integral_money) +
                    parseFloat(this.order.coupon_money) +
                    parseFloat(discountmoney) +
                    parseFloat(this.order.depositmoney) +
                    (this.order.morediscounts_money
                      ? parseFloat(this.order.morediscounts_money)
                      : 0) +
                    (this.order.fullMinusMoney ? parseFloat(this.order.fullMinusMoney) : 0) +
                    (this.order.extraFullMinusMoney
                      ? parseFloat(this.order.extraFullMinusMoney)
                      : 0))
              : 0
          ).toFixed(2)
          if (sessionStorage.getItem('recommendclose') == 1) that.order.recommenditemlist = []
          that.relationorders = that.order.relationorders
          let list = res.data.itemlist
          for (let i in list) {
            if (list[i].isadditem) {
              that.isadditemFlag = 1
              break
            }
          }
          for (let i in list) {
            if (list[i].couponname) {
              that.couponname = list[i].couponname
              break
            }
          }
          that.list = list
          var nowTime = new Date().getTime()
          var futureTime = null
          if (that.order.orderstatus == 7) {
            // 待确认收货
            if (that.order.shutdowntime) {
              that.order.shiptime = that.order.shutdowntime
            }
            if (
              that.order.shiptime != '' &&
              that.order.shiptime != undefined &&
              that.order.auto_sure_time != '' &&
              that.order.auto_sure_time != undefined
            ) {
              futureTime =
                that.parserDate(that.order.shiptime).getTime() +
                parseInt(that.order.auto_sure_time) * 24 * 60 * 60 * 1000
              that.time = futureTime - nowTime
              if (that.time < 86400000) {
                that.format = 'HH 时 mm 分 ss 秒'
              }
              if (that.time < 3600000) {
                that.format = 'mm 分 ss 秒'
              }
              if (that.time < 60000) {
                that.format = 'ss 秒'
              }
            }
          } else if (that.order.orderstatus == 1) {
            // 待付款
            if (
              that.order.ordertime != '' &&
              that.order.ordertime != undefined &&
              that.order.close_time != 0 &&
              that.order.close_time != '' &&
              that.order.close_time != undefined
            ) {
              futureTime =
                that.parserDate(that.order.ordertime).getTime() +
                parseInt(that.order.close_time) * 1000 * 60
              that.time = futureTime - nowTime
              if (that.time < 86400000) {
                that.format = 'HH 时 mm 分 ss 秒'
              }
              if (that.time < 3600000) {
                that.format = 'mm 分 ss 秒'
              }
              if (that.time < 60000) {
                that.format = 'ss 秒'
              }
            }
          }
        }
      })
    },
    /**多包裹列表 */
    goMorePackage: function () {
      this.$router.push({
        path: '/splitdetails_order',
        query: {
          id: this.order.id,
          issplit: this.order.issplit
        }
      })
    },
    /**物流走件详情 */
    goLogistics: function () {
      if (this.transList.length) {
        this.$router.push({
          path: '/logistics',
          query: {
            id: this.transList[this.transIndex].id,
            tranno: this.transList[this.transIndex].transno
          }
        })
      }
    },
    transHandle: function () {
      /**
       * orderstatus
       * 2已付款 3已收货 6已完成 7已发货
       * -----------
       * status
       * 3部分发货 4已发货 5部分签收 6待评价
       * -----------
       * issplit
       * 是否已拆单 0否 1是
       * */
      if (
        (this.order.orderstatus == 2 &&
          (this.order.status == 3 ||
            this.order.status == 4 ||
            this.order.status == 5 ||
            this.order.status == 6)) ||
        ((this.order.orderstatus == 3 || this.order.orderstatus == 6) && this.order.status == 6) ||
        this.order.orderstatus == 7
      ) {
        if (this.order.issplit == 1) {
          this.getSplitData()
        } else {
          this.getLogistics(this.order.id)
        }
      }
    },
    /**顶部物流信息跳转 */
    tranClick: function () {
      if (this.order.issplit == 0) {
        this.$router.push({
          path: '/logistics',
          query: {
            id: this.order.id
          }
        })
      } else if (this.order.issplit == 1) {
        this.$router.push({
          path: '/splitdetails',
          query: {
            id: this.order.id
          }
        })
      } else if (this.order.issplit == 2) {
        this.$router.push({
          path: '/splitdetails_order',
          query: {
            id: this.order.id
          }
        })
      }
    },
    /**获取拆单数据 */
    getSplitData: function () {
      var url = this.$ajax.getParentOrderById_URL + '?id=' + this.order.id
      var that = this
      that.$customRequestAjax(url).then(async (res) => {
        if (res.data.code === 200) {
          for (const [index, item] of res.data.list.entries()) {
            try {
              await that.getLogistics(item.id)
            } catch (error) {
              console.error(`Error fetching logistics for item ${item.id}:`, error)
            }
          }
        }
      })
    },
    /**获取物流数据 */
    getLogistics: async function (id) {
      var url = this.$ajax.getLogistics_URL + '?id=' + id
      var that = this
      var { data } = await that.$customRequestAjax(url)
      if (data.code === 200) {
        data.othertrans.forEach((item, index) => {
          if (item.transno && item.transname) {
            let index = that.transList.findIndex((transItem) => item.transno === transItem.transno)
            if (index < 0) {
              that.transList.push({ ...item, ...{ id: id } })
            }
          }
        })
      }
    },
    parserDate: function (date) {
      var t = Date.parse(date.replace(/-/g, '/'))
      if (!isNaN(t)) {
        return new Date(Date.parse(date.replace(/-/g, '/')))
      } else {
        return new Date()
      }
    },
    closeRecommend: function () {
      this.order.recommenditemlist = []
      sessionStorage.setItem('recommendclose', 1)
    },
    relationordersFn: function () {
      if (this.order.issplit == 0) {
        this.$router.replace({
          path: '/orderdetails',
          query: {
            id: this.relationorders[0].id
          }
        })
        this.$router.go()
      } else if (this.order.issplit == 1) {
        this.$router.push({
          path: '/splitdetails',
          query: {
            id: this.order.id,
            is_coupon: this.order.is_coupon ? this.order.is_coupon : 0
          }
        })
      } else if (this.order.issplit == 2) {
        this.$router.push({
          path: '/splitdetails_order',
          query: {
            id: this.order.id,
            is_coupon: this.order.is_coupon ? this.order.is_coupon : 0
          }
        })
      }
    },
    address: function (isedit) {
      if (isedit == 1) {
        let param = {
          type: 'orderdetails',
          orderid: this.order.id,
          chooseid: this.$route.query.chooseid,
          addressid: this.order.addressid,
          orderstatus: this.order.orderstatus
        }
        let ispaytrans = 0,
          items = [],
          nums = []

        this.list.forEach((item, index) => {
          if (item.freightrule.payfreight == 1 || this.order.activitytype != 0) {
            ispaytrans = 1
          }
          items.push(item.itemid)
          nums.push(item.nums)
        })

        if (ispaytrans == 1) {
          param.transfee = this.order.trans_money
          param.items = items.join(',')
          param.nums = nums.join(',')
          param.activitytype = this.order.activitytype
          if (this.order.activityid) {
            param.activityid = this.order.activityid
          }
        }
        this.$router.replace({ path: '/addresschoose', query: param })
      }
    },
    productDetailFn(items) {
      if (items.limitid) {
        let linkParams = 'limitid=' + items.limitid
        if (items.limit_new == 1) {
          linkParams += '&ad_v=2&itemid=' + items.itembaseid
        }
        window.location.href =
          '/static/wx/html/time-limit-actpage/timelimitproduct.html?' + linkParams
      } else if (items.integralitemid && items.integralitemid != '') {
        this.$router.push({
          path: '/integralproduct',
          query: {
            itemid: items.integralitemid,
            integralType: items.integraltype == 1 ? 0 : 1,
            integral: items.integralcount,
            status: items.integralstatus,
            itembaseid: items.itembaseid
          }
        })
      } else if (
        this.order.is_coupon != 1 &&
        items.isgoiteminfo == 1 &&
        items.isadditem != 1 &&
        items.isprogift == 0 &&
        items.ischangebuy == 0 &&
        items.isgift == 0 &&
        items.isexchangebuy == 0
      ) {
        this.$clickburiedPoint({
          url: 'ckysdatacenter/itemclick/save',
          data: {
            itemid: items.itembaseid,
            scenepoint: 'ORDERDETAIL',
            scenedesc: this.id
          }
        })
        this.$router.push({
          path: '/productdetail',
          query: {
            itemid: items.itembaseid,
            live_id: items.liveid
          }
        })
      } else if (
        items.ischangebuy == 1 ||
        items.isexchangebuy == 1 ||
        items.isgift == 1 ||
        items.isdefectivegood == 1
      ) {
        this.$router.push({
          path: '/productdetail',
          query: {
            itemid: items.itembaseid,
            type: 'changebuyproductdetail',
            gift: items.isgift ? 'gift' : ''
          }
        })
      }
    },
    // refundClick: function () {
    //   this.$router.push('/aftertype')
    // },
    // refundAllClick: function () {
    //   this.$router.push('/aftertype')
    // },
    homeClick: function () {
      this.$router.push('/')
    },
    delOrder: function () {
      var url = this.$ajax.deleteOrder_URL
      var data = {
        id: this.order.id
      }
      var that = this
      that.$dialog
        .confirm({
          message: '确认删除订单？',
          className: 'collect_button_alert',
          cancelButtonColor: '#FC0324',
          confirmButtonColor: '#FFFCFC',
          closeOnPopstate: true
        })
        .then(function () {
          // on confirm
          that.$customRequestAjax.post(url, data).then((res) => {
            if (res.data.code === 200) {
              that.$store.commit('ORDER_INIT_DATA', 1)
              that.$router.replace({
                path: '/myorder',
                query: {
                  id: 0
                }
              })
            }
          })
        })
        .catch(function () {
          // on cancel
        })
    },
    buyAgain: function () {
      var url = this.$ajax.addShoppingCart_URL
      var skuId = []
      var itemnum = []
      var liveId = []
      var list = this.order.itemlist
      this.order.itemlist.map((item) => {
        if (
          item.isgift == 0 &&
          !item.isadditem &&
          item.isprogift == 0 &&
          item.ischangebuy == 0 &&
          item.isexchangebuy == 0
        ) {
          skuId.push(item.itemid)
          itemnum.push(item.nums)
          liveId.push(item.liveid)
        }
      })
      var data = {
        skuid: skuId.join(),
        itemnum: itemnum.join(),
        live_ids: liveId.join()
      }
      if (!data.skuid.length) {
        this.$router.push('/cart')
        return
      }
      var that = this
      that.$customRequestAjax.post(url, data).then((res) => {
        if (res.data.code === 200) {
          that.$store.commit('ADD_CART_INIT_DATA', 1)
          that.dataCollection(list)
          that.$router.push('/cart')
        }
      })
    },
    // 埋点-加入购物车
    dataCollection(list) {
      let params
      for (let i in list) {
        if (
          list[i].isgift == 0 &&
          list[i].isadditem == 0 &&
          list[i].isprogift == 0 &&
          list[i].ischangebuy == 0
        ) {
          params = {
            productId_var: '',
            productName_var: list[i].name,
            firstCat_var: '',
            productType_var: '',
            productFormat_var: list[i].itemid
          }

          gio('track', 'addToCart', params)
        }
      }
    },
    afterDetailsClick: function (numtype, items) {
      if (numtype == 0) {
        this.$router.push({
          path: '/afterdetails',
          query: {
            id: items.refund_id
          }
        })
      }
    },
    closeDialogFn: function () {
      this.afterSalesShow = false
    },
    beforeClose: function (action, done) {
      if (action === 'confirm') {
        setTimeout(done, 1000)
      } else {
        done(false)
      }
    },
    confirmDialog: function () {
      this.keFu()
      this.afterSalesShow = false
    },
    cancelDialog: function () {
      window.location.href = 'tel: ' + this.kefuPhone
    },
    handlePickerConfirm(v) {
      this.picker.anchor = v
      if (v[0].index == 0) {
        refundGoodsList({ that: this, orderGoodsCheckHide: true })
        // 拆单订单：allrefund 是否整单退款 1-是 0-否
        refundActivityPrizeTip({
          that: this,
          obj: { ...refundGoods({ selectedList: this.refundGoods }), allrefund: 1 }
        })
      } else if (v[0].index == 1) {
        this.$router.push({
          path: '/splitdetails',
          query: {
            id: this.order.id
          }
        })
      }
    },
    afterSalesFn: function (numtype, items) {
      this.afterSalesType = numtype
      afterSalesHandle({ that: this, numtype, items })
    },
    afterSalesSubmit: function (selectedList) {
      refundActivityPrizeTip({ that: this, obj: refundGoods({ selectedList }) })
    },
    closeOrder: function (type) {
      var url = this.$ajax.cancelOrder_URL
      var data = {
        id: this.order.id
      }
      var that = this
      if (type == 'close') {
        that.$customRequestAjax.post(url, data).then((res) => {
          if (res.data.code === 200) {
            that.$store.commit('ORDER_INIT_DATA', 1)
            that.getData()
          }
        })
      } else {
        that.$dialog
          .confirm({
            message: '确认放弃优惠，取消订单吗？',
            className: 'collect_button_alert',
            cancelButtonColor: '#FC0324',
            cancelButtonText: '确认取消',
            confirmButtonColor: '#FFFCFC',
            confirmButtonText: '继续支付',
            closeOnPopstate: true
          })
          .then(function () {
            // on confirm
            that.goBuy()
          })
          .catch(function () {
            // on cancel
            that.$customRequestAjax.post(url, data).then((res) => {
              if (res.data.code === 200) {
                that.$store.commit('ORDER_INIT_DATA', 1)
                that.getData()
              }
            })
          })
      }
    },
    goBuy: function () {
      if (this.order.isoversea == 1 && isWx != 3) {
        download_dialog(this)
        return
      }
      this.$store.commit('ORDER_INIT_DATA', 1)
      if (this.order.is_coupon == 1) {
        window.location.href =
          './static/wx/html/20190820/buyCoupon/pay.html?orderId=' +
          this.order.id +
          '&m=' +
          this.order.nopay_money
      } else {
        let skuids = []
        this.order.itemlist.forEach(function (item) {
          skuids.push(item.itemid)
        })
        if (this.order.is_drainage == 1) {
          this.$router.push({
            path: '/pay',
            query: {
              id: this.order.id,
              money: this.order.nopay_money,
              yl: 1,
              ann: 1,
              anncc: 1,
              skuids: JSON.stringify(skuids)
            }
          })
        } else {
          if (this.order.no.indexOf('pt') >= 0) {
            let ptid = this.order.no.replace('pt', '')
            window.location =
              '/static/wx/html/new-group/ptpay.html?ptid=' +
              ptid +
              '&code=' +
              this.order.ptcode +
              '&m=' +
              this.order.nopay_money
          } else {
            this.$router.push({
              path: '/pay',
              query: {
                id: this.order.id,
                money: this.order.nopay_money,
                skuids: JSON.stringify(skuids)
              }
            })
          }
        }
      }
    },
    confirm: function () {
      var url = this.$ajax.confirmOrderItem_URL
      var data = {
        id: this.order.id
      }
      var that = this
      if (that.order.issplit == 1) {
        that.$router.push({
          path: '/splitdetails',
          query: {
            id: that.order.id
          }
        })
      } else {
        if (that.order.orderstatus == 2 && that.order.status == 3) {
          this.$dialog
            .alert({
              message: '您的包裹还没有全部发货，不能确认收货！',
              className: 'percen_button_alert',
              confirmButtonColor: '#FFFCFC',
              confirmButtonText: '知道了',
              closeOnPopstate: false
            })
            .then(function () {
              // on confirm
            })
            .catch(function () {
              // on cancel
            })
        } else {
          this.$dialog
            .confirm({
              message: '确认收货？',
              className: 'collect_button_alert',
              cancelButtonColor: '#FC0324',
              confirmButtonColor: '#FFFCFC',
              closeOnPopstate: true
            })
            .then(function () {
              that.$customRequestAjax.post(url, data).then((res) => {
                if (res.data.code === 200) {
                  that.$store.commit('ORDER_INIT_DATA', 1)
                  if (res.data.noticmsg) that.$toast(res.data.noticmsg)
                  that.getData()
                }
              })
            })
            .catch(function () {
              // on cancel
            })
        }
      }
    },
    selfMotionConfirm: function () {
      var url = this.$ajax.confirmOrderItem_URL
      var data = {
        id: this.order.id
      }
      this.$customRequestAjax.post(url, data).then((res) => {
        if (res.data.code === 200) {
          this.getData()
        }
      })
    },
    evaluate: function (type, items) {
      if (type == 'item') {
        this.$store.commit('ORDER_INIT_DATA', 1)
        this.$router.push({
          path: '/producteval',
          query: {
            orderid: this.order.id,
            skuid: items.itemid,
            itemid: items.itembaseid
          }
        })
        sessionStorage.setItem('evaluate_product', JSON.stringify(items))
      }
    },
    // 去加购
    goProductList() {
      let skuids = [],
        oid = this.order.id,
        obj
      this.order.itemlist.map((item) => {
        if (
          item.isgift == 0 &&
          item.isadditem == 0 &&
          item.isprogift == 0 &&
          item.ischangebuy == 0
        ) {
          skuids.push(item.itemid)
        }
      })
      localStorage.removeItem('shopConfirmResult')
      obj = {
        skuids: skuids.join(),
        type: 'orderInfo',
        oid: oid
      }
      if (this.order.isexchange == 1 && this.order.changebuystatus != 1) {
        obj.isexchange = 1
      }
      if (this.order.isexchange != 1 && this.order.changebuystatus == 1) {
        obj.changebuystatus = 1
      }
      this.$router.push({
        path: '/allProductList',
        query: obj
      })
    },
    keFu: function () {
      var goodslist = [],
        goodsnum = 0,
        money
      this.order.itemlist.map((item) => {
        goodslist.push({
          name: item.name,
          pictureUrl: encodeURIComponent(item.img_path)
        })
        goodsnum += parseInt(item.nums)
      })
      if (this.order.orderstatus == 1 && this.order.status == 1) {
        money = (
          parseFloat(this.order.order_money) -
          (parseFloat(this.order.integral_money) +
            parseFloat(this.order.coupon_money) +
            parseFloat(this.order.discount_money) +
            parseFloat(this.order.depositmoney))
        ).toFixed(2)
      } else if (this.order.orderstatus != 1 && this.order.status != 1) {
        money = parseFloat(this.order.pay_money).toFixed(2)
      }
      var k =
        'order_status=0&status_custom=' +
        this.order.orderstatus_text +
        '&create_time=' +
        new Date(this.order.ordertime.replace(/-/g, '/')).getTime() +
        '&order_code=' +
        this.order.no +
        '&order_url=' +
        encodeURIComponent(window.location.href) +
        '&goods_count=' +
        goodsnum +
        '&total_fee=' +
        parseInt(parseFloat(money) * 100) +
        '&goods=' +
        JSON.stringify(goodslist)
      kefu(1, k)
    },
    copy: function () {
      copyContentH5(this.order.no, 'orderNo')
    }
  }
}
</script>

<style scoped lang="scss">
.color-8B {
  color: #8b8b8b;
}
.changebuy {
  // margin-bottom: 0 !important;
}
.details {
  header {
    height: 1.15rem;
    background: linear-gradient(108deg, rgba(252, 3, 36, 1) 0%, rgba(238, 116, 47, 1) 100%);
    background: -webkit-linear-gradient(108deg, rgba(252, 3, 36, 1) 0%, rgba(238, 116, 47, 1) 100%);
    background: -ms-linear-gradient(108deg, rgba(252, 3, 36, 1) 0%, rgba(238, 116, 47, 1) 100%);
    background: -o-linear-gradient(108deg, rgba(252, 3, 36, 1) 0%, rgba(238, 116, 47, 1) 100%);
    background: -moz-linear-gradient(108deg, rgba(252, 3, 36, 1) 0%, rgba(238, 116, 47, 1) 100%);
    display: flex;
    display: -webkit-flex;
    display: -ms-flex;
    display: -o-flex;
    display: -moz-flex;
    flex-direction: column;
    -webkit-flex-direction: column;
    -ms-flex-direction: column;
    -o-flex-direction: column;
    -moz-flex-direction: column;
    justify-content: center;
    -webkit-justify-content: center;
    -ms-justify-content: center;
    -o-justify-content: center;
    -moz-justify-content: center;
    p {
      font-size: 0.18rem;
      font-weight: 600;
      color: rgba(255, 255, 255, 1);
      line-height: 0.25rem;
      display: flex;
      display: -webkit-flex;
      display: -ms-flex;
      display: -o-flex;
      display: -moz-flex;
      justify-content: center;
      -webkit-justify-content: center;
      -ms-justify-content: center;
      -o-justify-content: center;
      -moz-justify-content: center;
      align-items: center;
      -webkit-align-items: center;
      -ms-align-items: center;
      -o-align-items: center;
      -moz-align-items: center;
      margin-bottom: 0.07rem;
      img {
        margin-right: 0.08rem;
        width: 0.18rem;
        height: 0.18rem;
      }
    }
    span {
      display: block;
      font-size: 0.12rem;
      font-weight: 600;
      color: rgba(255, 239, 237, 1);
      line-height: 0.17rem;
      text-align: center;
      .van-count-down {
        color: rgba(255, 239, 237, 1);
        font-size: 0.12rem;
      }
    }
  }
  .recommend {
    padding: 0.12rem 0.15rem !important;
    .title {
      position: relative;
      img {
        width: 0.86rem;
        height: 0.22rem;
        margin-right: 0.08rem;
      }
      span {
        color: #6c6c6c;
      }
      .close {
        position: absolute;
        right: 0;
        top: 50%;
        transform: translateY(-50%);
      }
    }
    .recommenditem {
      text-align: center;
      margin-right: 0.1rem;
      margin-top: 0.1rem;
      img {
        width: 1.01rem;
        height: 1.01rem;
      }
      .price {
        margin-top: 0.05rem;
        white-space: nowrap;
        font-size: 0;
        .cost_price {
          margin-left: 0.03rem;
          color: #6c6c6c;
          text-decoration: line-through;
          sub {
            font-size: 0.09rem;
          }
        }
      }
      > span {
        display: inline-block;
        border: 0.005rem solid #fc0324;
        border-radius: 0.03rem;
        padding: 0.01rem 0.04rem;
      }
    }
  }
  .address {
    background: #fff;
    border-radius: 0.03rem;
    padding: 0.2rem 0.15rem;
    margin: 0.1rem 0.11rem 0;
    ul {
      li {
        margin-top: 0.15rem;
        &:first-of-type {
          margin-top: 0;
        }
        .p {
          display: flex;
          display: -webkit-flex;
          display: -ms-flex;
          display: -o-flex;
          display: -moz-flex;
          align-items: center;
          -webkit-align-items: center;
          -ms-align-items: center;
          -o-align-items: center;
          -moz-align-items: center;
          font-size: 0.12rem;
          font-weight: 600;
          color: rgba(29, 30, 30, 1);
          line-height: 0.17rem;
          b {
            display: flex;
            display: -webkit-flex;
            display: -ms-flex;
            display: -o-flex;
            display: -moz-flex;
            align-items: center;
            -webkit-align-items: center;
            -ms-align-items: center;
            -o-align-items: center;
            -moz-align-items: center;
          }
          img {
            &:first-of-type {
              width: 0.18rem;
              height: 0.16rem;
              margin-right: 0.05rem;
            }
            &:last-of-type {
              width: 0.16rem;
              height: 0.16rem;
              /*padding: 0 0.015rem;*/
              /*margin-left: 0.05rem;*/
            }
          }
        }
        span {
          display: block;
          font-size: 0.1rem;
          font-weight: 400;
          color: rgba(134, 134, 134, 1);
          line-height: 0.16rem;
          margin-top: 0.06rem;
          padding-left: 0.23rem;
        }
        /*&.trans {*/
        /*  margin-bottom: 0.15rem;*/
        /*}*/
      }
    }
  }
  .order {
    margin: 0.1rem 0.11rem 0;
    padding: 0.2rem 0.15rem 0;
    background: #fff;
    &.order-top-pad {
      padding-top: 0.35rem;
      position: relative;
    }
    > span {
      position: absolute;
      right: 0;
      top: 0;
      display: block;
      background: #ffecef;
      padding: 0.04rem 0.11rem;
      border-radius: 0 0.03rem 0 0.03rem;
    }
    ul {
      background: #fff;
      border-radius: 0.03rem;
      li {
        /*padding-bottom: 0.1rem;*/
        &:nth-last-of-type(2) {
          /*border-bottom: 1px solid #D8D8D8;*/
        }
        &:last-of-type {
          border-top: 1px solid #d8d8d8;
          padding: 0;
          margin-top: 0.1rem;
          display: flex;
          display: -moz-flex;
          display: -o-flex;
          display: -ms-flex;
          display: -webkit-flex;
          justify-content: center;
          -moz-justify-content: center;
          -o-justify-content: center;
          -ms-justify-content: center;
          -webkit-justify-content: center;
          align-items: center;
          -moz-align-items: center;
          -o-align-items: center;
          -ms-align-items: center;
          -webkit-align-items: center;
          height: 0.37rem;
          img {
            width: 0.15rem;
            height: 0.15rem;
            margin-right: 0.04rem;
          }
          font-size: 0.12rem;
          font-weight: 400;
          color: rgba(54, 54, 54, 1);
          line-height: 0.17rem;
        }
        .orderlist {
          display: flex;
          display: -moz-flex;
          display: -o-flex;
          display: -ms-flex;
          display: -webkit-flex;
          align-items: center;
          -moz-align-items: center;
          -o-align-items: center;
          -ms-align-items: center;
          -webkit-align-items: center;
          > .img {
            width: 0.8rem;
            height: 0.8rem;
            margin-right: 0.07rem;
            position: relative;
            img {
              &:first-of-type {
                width: 100%;
                height: 100%;
              }
            }
          }
          .ordercontent {
            flex: 1;
            -webkit-flex: 1;
            -o-flex: 1;
            -moz-flex: 1;
            -ms-flex: 1;
            p {
              font-size: 0.13rem;
              font-weight: 400;
              color: rgba(41, 41, 41, 1);
              line-height: 0.18rem;
              display: flex;
              display: -moz-flex;
              display: -o-flex;
              display: -ms-flex;
              display: -webkit-flex;
              justify-content: space-between;
              -moz-justify-content: space-between;
              -o-justify-content: space-between;
              -ms-justify-content: space-between;
              -webkit-justify-content: space-between;
              align-items: center;
              -moz-align-items: center;
              -o-align-items: center;
              -ms-align-items: center;
              -webkit-align-items: center;
              > b {
                font-size: 0.1rem;
                font-weight: 400;
                color: rgba(108, 108, 108, 1);
                line-height: 0.14rem;
                display: block;
              }
            }
            > b {
              font-size: 0.11rem;
              font-weight: 400;
              color: rgba(108, 108, 108, 1);
              line-height: 0.16rem;
              display: block;
              margin-top: 0.05rem;
              margin-bottom: 0.1rem;
            }
          }
        }
        .btn1 {
          margin: 5px 0;
        }
        .ys {
          overflow: hidden;
        }
        .ysale {
          font-size: 0.12rem;
          float: left;
          height: 0.27rem;
          white-space: nowrap;
          width: 100%;
          text-overflow: ellipsis;
          display: flex;
          align-items: center;
          img {
            width: 0.12rem;
            margin-left: 0.04rem;
          }
          .txt {
            font-size: 0.12rem;
            color: #f12a0e;
            transform: scale(0.92, 0.92);
            margin-left: -0.03rem;
            line-height: 0.17rem;
          }
        }
        .btn {
          position: static !important;
          /*justify-content: space-between;*/
        }
      }
    }
  }
  .money {
    padding: 0.2rem 0.15rem;
    margin: 0.1rem 0.11rem 0;
    background: #fff;
    ul {
      &:first-of-type {
        padding-bottom: 0.15rem;
      }
      &:last-of-type {
        border-top: 1px solid #d8d8d8;
        padding-top: 0.16rem;
        li {
          &:last-of-type {
            justify-content: flex-end;
            -moz-justify-content: flex-end;
            -o-justify-content: flex-end;
            -ms-justify-content: flex-end;
            -webkit-justify-content: flex-end;
            font-size: 0.12rem;
            font-weight: 400;
            color: rgba(61, 61, 61, 1);
            line-height: 0.17rem;
            b {
              font-size: 0.16rem;
              font-weight: 400;
              color: rgba(252, 3, 36, 1);
              line-height: 0.17rem;
              margin-left: 0.05rem;
            }
          }
        }
      }
      li {
        &:first-of-type {
          margin-top: 0;
        }
        margin-top: 0.1rem;
        font-size: 0.12rem;
        font-weight: 400;
        color: rgba(61, 61, 61, 1);
        line-height: 0.17rem;
        display: flex;
        display: -moz-flex;
        display: -o-flex;
        display: -ms-flex;
        display: -webkit-flex;
        justify-content: space-between;
        -moz-justify-content: space-between;
        -o-justify-content: space-between;
        -ms-justify-content: space-between;
        -webkit-justify-content: space-between;
        b {
          font-size: 0.12rem;
          font-weight: 400;
          color: rgba(51, 51, 51, 1);
          line-height: 0.17rem;
        }
      }
    }
  }
  .price {
    font-size: 0.14rem;
    margin-top: 0.1rem;
    padding: 0;
    margin-left: 0;
    display: flex;
    .xprice {
      font-size: 0;
    }
    sub {
      font-weight: normal;
      font-size: 0.12rem;
      vertical-align: baseline;
    }
    b {
      font-size: 0.14rem;
      line-height: 0.2rem;
      font-weight: 500;
    }
    sup {
      font-size: 0.11rem;
      vertical-align: baseline;
      font-weight: 500;
    }
    .tags {
      color: #ffffff;
      font-size: 0.13rem;
      height: 0.22rem;
      line-height: 0.22rem;
      background: linear-gradient(270deg, #f73864 0%, #fc0324 100%);
      padding: 0 0.12rem;
      border-radius: 0.11rem;
      position: relative;
      top: -0.02rem;
      white-space: normal;
      margin-left: 0.08rem;
    }
  }
  .orderSource {
    background: #fff;
    margin: 0.1rem 0.11rem 0.55rem;
    padding: 0.2rem 0.15rem;
    border-radius: 0.03rem;
    ul {
      li {
        font-size: 0.12rem;
        font-weight: 400;
        color: rgba(61, 61, 61, 1);
        line-height: 0.17rem;
        margin-top: 0.1rem;
        &:first-of-type {
          margin-top: 0;
        }
        b {
          font-size: 0.12rem;
          font-weight: 600;
          color: rgba(51, 51, 51, 1);
          line-height: 0.17rem;
          margin-left: 0.15rem;
          #orderNo {
            border-width: 0;
            outline: none;
            position: absolute;
            top: -99rem;
          }
        }
        i {
          font-style: normal;
          font-size: 0.1rem;
          font-weight: 400;
          color: rgba(74, 144, 226, 1);
          line-height: 0.17rem;
          margin-left: 0.06rem;
        }
      }
    }
  }
  footer {
    display: flex;
    display: -moz-flex;
    display: -o-flex;
    display: -ms-flex;
    display: -webkit-flex;
    justify-content: flex-end;
    -moz-justify-content: flex-end;
    -o-justify-content: flex-end;
    -ms-justify-content: flex-end;
    -webkit-justify-content: flex-end;
    padding: 0 0.1rem;
    background: #fff !important;
    border-top: 0.005rem solid #bdbdbd !important;
    position: fixed !important;
    left: 0;
    right: 0;
    bottom: 0;
    button {
      margin: 0.09rem 0;
    }
  }
  .homeBtn {
    z-index: 10;
    position: fixed;
    right: 0.17rem;
    bottom: 0.8rem;
    width: 0.4rem;
    height: 0.4rem;
    border-radius: 50%;
    background: rgba(255, 255, 255, 1);
    box-shadow: 0 0.01rem 0.05rem 0 rgba(159, 159, 159, 0.5);
    -webkit-box-shadow: 0 0.01rem 0.05rem 0 rgba(159, 159, 159, 0.5);
    -moz-box-shadow: 0 0.01rem 0.05rem 0 rgba(159, 159, 159, 0.5);
    -ms-box-shadow: 0 0.01rem 0.05rem 0 rgba(159, 159, 159, 0.5);
    -o-box-shadow: 0 0.01rem 0.05rem 0 rgba(159, 159, 159, 0.5);
    display: flex;
    display: -moz-flex;
    display: -ms-flex;
    display: -webkit-flex;
    display: -o-flex;
    flex-direction: column;
    -moz-flex-direction: column;
    -ms-flex-direction: column;
    -webkit-flex-direction: column;
    -o-flex-direction: column;
    justify-content: center;
    -moz-justify-content: center;
    -ms-justify-content: center;
    -webkit-justify-content: center;
    -o-justify-content: center;
    align-items: center;
    -moz-align-items: center;
    -ms-align-items: center;
    -webkit-align-items: center;
    -o-align-items: center;
    img {
      width: 0.4rem;
      height: 0.4rem;
      display: block;
    }
  }
  .dialog-close {
    width: 0.2rem;
    height: 0.2rem;
    position: absolute;
    top: 0.06rem;
    right: 0.06rem;
  }
}
.btn {
  margin-top: 0.1rem;
  display: flex;
  display: -webkit-flex;
  display: -ms-flex;
  display: -o-flex;
  display: -moz-flex;
  justify-content: flex-end;
  -webkit-justify-content: flex-end;
  -ms-justify-content: flex-end;
  -o-justify-content: flex-end;
  -moz-justify-content: flex-end;
  .grayBtn {
    display: block;
    margin-left: 0.1rem;
    min-width: 0.7rem;
    height: 0.27rem;
    border-radius: 0.14rem;
    border: 0.01rem solid rgba(96, 96, 96, 1);
    font-size: 0.12rem;
    font-weight: 400;
    color: rgba(38, 38, 38, 1);
    line-height: 0.27rem;
    background: none;
    outline: none;
  }
  .redBtn {
    display: block;
    margin-left: 0.1rem;
    min-width: 0.7rem;
    height: 0.27rem;
    border-radius: 0.14rem;
    border: 1px solid rgba(252, 3, 36, 1);
    font-size: 0.12rem;
    font-weight: 400;
    color: rgba(252, 3, 36, 1);
    line-height: 0.27rem;
    background: none;
    outline: none;
  }
}
</style>
<style lang="scss">
.freightrule_box {
  overflow: hidden;
}
.freightrule_box .block > div {
  height: 80%;
  position: relative;
  background: #ffffff;
  padding: 0.1rem 0;
  overflow: hidden;
}
.freightrule_box .block p {
  margin: 0;
}
.freightrule_box .block .freightrule {
  padding-top: 0;
  div {
    padding: 0;
  }
}
.details {
  .after-sales-dialog {
    .van-dialog__header {
      padding-top: 0.06rem;
    }
    .van-dialog__content {
      padding-top: 0.4rem;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/order/orderDetails.vue